import React, { memo } from 'react';
import {
    getWellnessImage,
    getWellnessMessage,
    getMessageClassName
} from '../../pages/Wellness/WellnessDesign';

const WellnessCharacter = memo(({
    hasAlarm,
    hasFriends,
    friendCount,
    friendStatus,
    tokenUserID,
    isStudying,
    isRest,
    className = '',
    onAlarmClick // 알람 버튼 클릭 핸들러 추가
}) => {
    const image = getWellnessImage(hasAlarm, hasFriends, isStudying, isRest);
    const message = getWellnessMessage(hasAlarm, hasFriends, friendCount, friendStatus, tokenUserID, isStudying, isRest, false);
    const messageClassName = getMessageClassName(hasAlarm, hasFriends, isStudying, isRest);

    return (
        <div className={`wellness-main ${className}`}>
            <div className="wellness-character">
                <img
                    src={image}
                    alt="꼬끼오 캐릭터"
                    className="chicken-image"
                    loading="eager"
                    fetchpriority="high"
                    onClick={onAlarmClick}
                    style={{ 
                        cursor: onAlarmClick ? 'pointer' : 'default'
                    }}
                    onMouseDown={(e) => {
                        if (onAlarmClick) {
                            e.target.style.transform = 'scale(0.95)';
                        }
                    }}
                    onMouseUp={(e) => {
                        if (onAlarmClick) {
                            e.target.style.transform = 'scale(1)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (onAlarmClick) {
                            e.target.style.transform = 'scale(1)';
                        }
                    }}
                />
            </div>

            <div className={`wellness-message ${messageClassName}`}>
                <>
                    <p dangerouslySetInnerHTML={{ __html: message.line1 }}></p>
                    {message.line2 && (
                        <p className="bold-line" dangerouslySetInnerHTML={{ __html: message.line2 }}></p>
                    )}
                </>
            </div>
        </div>
    );
});

export default WellnessCharacter;